import { Icons } from '@lemon/assets';

export const Footer = () => {
    return (
        <div className="w-full max-w-[1200px] mx-auto h-full flex flex-col items-center justify-center">
            <div className="relative w-full flex flex-col  justify-center bg-primary-black text-white h-[420px] px-4">
                <div className={`text-[28px] text-white`}>Contact Us</div>
                <div className="h-2" />

                <div className="text-[16px] text-white/60">콘텐츠 제휴, 마케팅, 사업 및 투자 관련 문의</div>

                <div className="h-6" />
                <a
                    href="http://pf.kakao.com/_xbdxlxin"
                    target="_blank"
                    rel="noreferrer"
                    className="w-[100px] h-10 flex items-center justify-center font-bold bg-white text-primary-black rounded-[4px] cursor-pointer"
                >
                    문의하기
                </a>

                <div className="h-[50px]" />
                <div className="border 1px solid white mb-[10px]" />

                <div className="flex justify-between pr-4 flex-wrap gap-y-4">
                    <div className="flex gap-[12px] items-center">
                        <a
                            href="https://apps.apple.com/kr/app/epyt-personal-color-k-beauty/id6746754789"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src={Icons.apple}
                                className="cursor-pointer h-8 md:h-10 w-auto"
                                onDragStart={e => e.preventDefault()}
                            />
                        </a>
                        <a
                            href="https://play.google.com/store/apps/details?id=kr.epyt.android"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src={Icons.google_play}
                                className="cursor-pointer h-8 md:h-10 w-auto"
                                onDragStart={e => e.preventDefault()}
                            />
                        </a>
                        <a href="https://www.instagram.com/epyt.archive/" target="_blank" rel="noreferrer">
                            <img
                                src={Icons.instagram}
                                className="cursor-pointer h-6 md:h-8 w-auto"
                                onDragStart={e => e.preventDefault()}
                            />
                        </a>
                        <a href="https://www.tiktok.com/@epyt.kr" target="_blank" rel="noreferrer">
                            <img
                                src={Icons.tictok}
                                className="cursor-pointer h-6 md:h-8 w-auto"
                                onDragStart={e => e.preventDefault()}
                            />
                        </a>
                    </div>

                    <div className="flex gap-4 justify-center items-center">
                        <span className="text-2xl font-bold "> & </span>
                        <img src={Icons.kit_slaon} className="h-6" />
                    </div>
                </div>

                <div className="absolute bottom-4 w-full text-center text-white/40 text-[12px]">
                    Copyright ©epyt. All Rights Reserved.
                </div>
            </div>
        </div>
    );
};
